import {useState, useMemo, useEffect} from "react";
import {useAtomValue, useSetAtom} from "jotai";
import {getAttachmentsLoadable} from "../store/attachmentsStore";
import {Attachment} from "../types/domain/attachment";
import {AttachmentsQuery} from "../services/fieldService";
import {isResourceSucceeded} from "../utils/resourceUtils";

export const useAttachments = (companyId: string | null, query: AttachmentsQuery) => {
    const [items, setItems] = useState<Attachment[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const {fieldId, farmId} = query;
    const [attachmentsLoadable, _fetchAttachments] = useMemo(
        () => getAttachmentsLoadable(companyId, {fieldId, farmId}),
        [companyId, fieldId, farmId],
    );
    const allAttachmentsResource = useAtomValue(attachmentsLoadable);
    const refresh = useSetAtom(_fetchAttachments);

    useEffect(() => {
        if (isResourceSucceeded(allAttachmentsResource)) {
            setItems(allAttachmentsResource.data);
            setIsLoading(false);
        } else {
            setIsLoading(true);
        }
    }, [allAttachmentsResource]);

    return {items, isLoading, refresh};
};
